export default __webpack_public_path__ + "static/media/Tech.418a5ad2.svg";